import { render, staticRenderFns } from "./TippedText.vue?vue&type=template&id=7858d0d9&scoped=true&"
import script from "./TippedText.vue?vue&type=script&lang=js&"
export * from "./TippedText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7858d0d9",
  null
  
)

export default component.exports